import { FunctionComponent } from "react";

import { BlacklistTable } from "../components/BlacklistTable";

/** The Blacklist tab of Do-not-contact; the page header with the tabs is DoNotContact's. */
export const BlacklistView: FunctionComponent = () => (
	<div className="w-full">
		<BlacklistTable />
	</div>
);
